import { render, staticRenderFns } from "./del-post-button.vue?vue&type=template&id=18127b7b&"
import script from "./del-post-button.vue?vue&type=script&lang=js&"
export * from "./del-post-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports